module.exports = __webpack_public_path__ + "img/世航动态选中.ab22f12a.png";